import { Button } from "@design-system/Inputs/Button";
import { Modal } from "@design-system/Modal";
import { useState, type FC } from "react";
import { useTranslation } from "react-i18next";
import { keys, RESOURCE_NAME } from "../../i18n";
import {
    type QuestionnaireCreationModalStep,
    type QuestionnaireTemplate,
} from "../../types";
import { QuestionnaireFormStep } from "./QuestionnaireFormStep";
import { TemplatesStep } from "./TemplatesStep";

export const CreateQuestionnaireModal: FC<{
    isTemplate?: boolean;
}> = ({ isTemplate }) => {
    const { t } = useTranslation(RESOURCE_NAME);
    const defaultStep = isTemplate ? "templates" : "questionnaireForm";
    const [step, setStep] =
        useState<QuestionnaireCreationModalStep>(defaultStep);
    const [template, setTemplate] = useState<QuestionnaireTemplate | undefined>(
        undefined,
    );
    const handleOpenChange = (open: boolean) => {
        if (!open) {
            setStep(defaultStep);
        }
    };
    return (
        <Modal onOpenChange={handleOpenChange}>
            <Modal.Trigger asChild>
                {isTemplate ? (
                    <Button
                        variant="flatPrimary"
                        size="sm"
                        id="create-questionnaire-from-template-modal-trigger"
                    >
                        {t(
                            keys.create_questionnaire_from_template_modal_trigger_label,
                        )}
                    </Button>
                ) : (
                    <Button variant="outlined" size="sm">
                        <Button.Icon name="plus" />
                        {t(keys.create_questionnaire_modal_trigger)}
                    </Button>
                )}
            </Modal.Trigger>
            <Modal.Overlay>
                {step === "templates" && (
                    <TemplatesStep
                        onStepChange={setStep}
                        onTemplateChange={setTemplate}
                    />
                )}
                {step === "questionnaireForm" && (
                    <QuestionnaireFormStep
                        template={template}
                        onStepChange={setStep}
                        onTemplateChange={setTemplate}
                    />
                )}
            </Modal.Overlay>
        </Modal>
    );
};
